import React, { useMemo } from "react";
import moment from "moment";
import parse from "html-react-parser";
import { trimHtmlContent } from "utils";
import "react-quill/dist/quill.snow.css";
import "../styles/notification.styles.css";
import YoutubeIcon from "assets/images/icons/youtube_icon.png";
import { useAppScope } from "master";

export const NotificationIndividualItem = ({
  data = {},
  trim = false,
  viewAllNotification,
  isPage = false,
}) => {
  const { isMWCD } = useAppScope();
  const { title, content, localCreatedDate, programName } = data;
  const dateFormatted = useMemo(
    () =>
      moment(localCreatedDate, "DD-MMM-YYYY HH:mm:ss A").format(
        "DD MMM, YYYY [at] hh:mm A"
      ),
    [localCreatedDate]
  );

  let parsedContent = trim ? trimHtmlContent(content, 130) : parse(content);

  return (
    <li
      className={`notification-item ${
        isPage ? "notification-page" : "notification-item-hover"
      }`}
      onClick={viewAllNotification}
    >
      {isMWCD && <img src={YoutubeIcon} alt="youtubeIcon" />}
      <span>
        <h5>{title}</h5>
        <div className="text-break">{parsedContent}</div>
        <div className="notification-item-footer">
          {!isMWCD && programName && (
            <div className="notification-badges">
              <span className="notification-badge">{programName}</span>
            </div>
          )}
          <span className="notifiation-date">{dateFormatted}</span>
        </div>
      </span>
    </li>
  );
};
